/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'v': {
    width: 16,
    height: 16,
    viewBox: '0 0 21.76 21.76',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle pid="0" class="cls-1" cx="10.88" cy="10.88" r="10.88"/><path pid="1" class="cls-2" d="M16.08 7.73l-4.65 4.65-.7.7-.9.9a.44.44 0 0 1-.62 0l-3.58-3.59"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/v.js